module.exports = __webpack_public_path__ + "img/1ad08b216cc6707245f7f561165848ee.6986c6d7.jpg";